import React, { useRef } from 'react';
import cx from 'classnames';
import useDrag from 'beautiful-react-hooks/useDrag';
import useDragEvents from 'beautiful-react-hooks/useDragEvents';
import { Overlay } from './Overlay';
import { Tile, TileProps } from '@vimily/bonjoro-ui-components-v2/PublishableEmbed';

export interface DraggableTileProps extends TileProps {
  onDragStart?: () => void;
  onDragEnd?: () => void;
  onDragEnter?: () => void;
  onDragExit?: () => void;
  dragContainerClassName?: string;
  orderNumber?: number;
}

export default function DraggableTile({
  onDragStart,
  onDragEnter,
  onDragExit,
  onDragEnd,
  dragContainerClassName,
  orderNumber,
  ...tileProps
}: DraggableTileProps) {
  const ref = useRef<HTMLDivElement>(null);

  const isDragging = useDrag(ref, {
    transfer: tileProps.detail,
  });

  const dragEvents = useDragEvents(ref);

  dragEvents.onDragStart(
    onDragStart ??
      (() => {
        // do nothing
      })
  );
  dragEvents.onDragEnd(
    onDragEnd ??
      (() => {
        // do nothing
      })
  );
  dragEvents.onDragEnter(
    onDragEnter ??
      (() => {
        // do nothing
      })
  );
  dragEvents.onDragExit(
    onDragExit ??
      (() => {
        // do nothing
      })
  );

  return (
    <div
      ref={ref}
      className={cx(
        dragContainerClassName,
        {
          'opacity-50': isDragging,
        },
        'relative'
      )}
    >
      <Overlay orderNumber={orderNumber} />
      <Tile
        {...tileProps}
        className={cx(tileProps.className, 'pointer-events-none')}
      />
    </div>
  );
}
